export default __webpack_public_path__ + "images/KG.c1f3663.png";